import { getConfig } from './config';

const MainService = {
  // Login API
  Login: data => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'Login', {
        method: 'POST',
        headers: getConfig().API_HEADDERS,
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetClientHomeData: (token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetClientHomeData', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  EmiratesInDropDown: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'EmiratesInDropDown', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  StatusInDropDown: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'StatusInDropDown', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  TypesInDropDown: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'TypesInDropDown', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetNextOrderNo: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetNextOrderNo', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetNewClientAppHomeData: (token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetNewClientAppHomeData', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Delivery Details
  GetDeliveryDetails: (deliveryId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + `Deliveries/${deliveryId}`, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get order details
  OrderByIdInClApp: (orderId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + `OrderByIdInClApp/${orderId}`, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  /** Full order DTO for edit (SaveOrder payload shape) */
  OrderById: (orderId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + `OrderById/${orderId}`, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  SaveOrder: (order, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'SaveOrder', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(order)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update Delivery Status
  UpdateDeliveryStatus: (deliveryId, status, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + `Deliveries/${deliveryId}/Status`, {
        method: 'PUT',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status })
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // save Order 
  SavePortalOrder: (order, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'SavePortalOrder', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(order)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  UpdatePortalOrder: (orderDto, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'UpdatePortalOrder', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(orderDto)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // upload Order List
  SavePortalOrderList: (orderList, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'SavePortalOrderList', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(orderList)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },


 // Get Reports
  GetReports: (filters, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'Reports', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(filters)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get User Profile
  GetUserProfile: (token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'Profile', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // GetNextBatchNo
  GetNextBatchNo: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetNextBatchNo', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS, 
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // LocationByEmirateId
  LocationByEmirateId: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'LocationByEmirateId/' + data, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS, 
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update User Profile
  UpdateUserProfile: (profileData, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'Profile', {
        method: 'PUT',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(profileData)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  
  // Update User Profile
  SaveClientAddress: (address, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'SaveClientAddress', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(address)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  
  GetClientAddress: (id) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetClientAddress/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  DeleteClientAddress: (id, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'DeleteClientAddress/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
           'Authorization': `Bearer ${token}`
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  MakeDefaultAddress: (id, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'MakeDefaultAddress/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
           'Authorization': `Bearer ${token}`
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  TodaysOrdersInPortal: (id) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'TodaysOrdersInPortal/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  RecentDeliveriesInPortal: (id) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'RecentDeliveriesInPortal/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  ClientById: (id,token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'ClientById/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
           'Authorization': `Basic ${token}`
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Track Orders by Voucher Numbers
  TrackOrdersByVoucherNo: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'TrackOrdersByVoucherNo', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  }, 
  // Track Orders by bill no
  TrackOrdersByBillNosPortal: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'TrackOrdersByBillNosPortal', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // Track Orders by customer
  TrackOrdersByCustomerInPortal: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'TrackOrdersByCustomerInPortal', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Order Status by Order ID
  OrderStatusByOrderId: (orderId) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'OrderStatusByOrderId/' + orderId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Customres
  CustomersInGridInPortal: (cid) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'CustomersInGridInPortal/' + cid, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Order History by Order ID
  OrderHistoryByOrderId: (orderId) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'OrderHistoryByOrderId/' + orderId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Status Options for Grid
  statusInGrid: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'statusInGrid', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Areas Options for Grid
  AreasInGrid: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'AreasInGrid', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Order Report
  OrderReportInPortal: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'OrderReportInPortal', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // Get Order Report
  CustomerOrderReportInPortal: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'CustomerOrderReportInPortal', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Order
  PrintOrder: (orderId) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintOrder/' + orderId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Client Orders
  PrintClientOrders: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintClientOrders', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print by Batch No
  PrintByBatchNo: (batchNo) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintByBatchNo/' + batchNo, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Order List
  PrintOrderList: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintOrderList', {
        method: 'POST',
        headers: getConfig().API_HEADDERS,
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Order List 2
  PrintOrderList2: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintOrderList2', {
        method: 'POST',
        headers: getConfig().API_HEADDERS,
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Today's Orders in Portal
  TodaysOrdersInPortal: (clientId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'TodaysOrdersInPortal/' + clientId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Search Orders with Pagination
  SearchOrders: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'SearchOrders', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Get Company Profile
  GetCompanyProfile: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetCompanyProfile', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Client Payment Reports
  ClientPaymentClientInList: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'ClientPaymentClientInList', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Individual Client Payment
  PrintIndClientPayment: (paymentId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintIndClientPayment/' + paymentId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Client Payment Summary
  PrintIndClientPaymentSummary: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintIndClientPaymentSummary', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Client Return Reports
  ClientReturnClientInList: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'ClientReturnClientInList', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Print Individual Client Return
  PrintIndClientReturn: (returnId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintIndClientReturn/' + returnId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // VAT Reports
  VatReportInList: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'VatReportInList', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update Client Profile
  UpdateClientProfile: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'UpdateClientProfile', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Registration APIs
  CheckMobileNoRegister: (mobileNo) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'CheckMobileNoRegister/' + mobileNo, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  RegisterClient: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'RegisterClient', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetCompanyProfile: () => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetCompanyProfile', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  LocationsAutoCompleteByEmirate: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'LocationsAutoCompleteByEmirate', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // RecentDeliveriesInPortal
  RecentDeliveriesInPortal: (clientId, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'RecentDeliveriesInPortal/' + clientId, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
// RecentDeliveriesInPortal
GetNotifications: (id, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetNotifications/' + id, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // UpdateClientBankDetails
  UpdateClientBankDetails: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'UpdateClientBankDetails', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  }  ,
  // ChangePassword
  ChangePassword: (data, token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'ChangePassword', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  }, 
  // GetPortalDashCounters
  GetPortalDashCounters: (token) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'GetPortalDashCounters', {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS,
          'Authorization': `Basic ${token}`
        },
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // CheckMobileNoTouble
  CheckMobileNoTouble: (mobileNo) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'CheckMobileNoTouble/' + mobileNo, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

// PrintByBatchNo
PrintByBatchNo: (numval) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'PrintByBatchNo/' + numval, {
        method: 'GET',
        headers: {
          ...getConfig().API_HEADDERS
        }
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // RecoverClient
  RecoverClient: (data) => {
    return new Promise((resolve, reject) => {
      fetch(getConfig().API_BASE_URL + 'RecoverClient', {
        method: 'POST',
        headers: {
          ...getConfig().API_HEADDERS
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(responseJson => {
          resolve(responseJson);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

};

export default MainService;
